import { render, staticRenderFns } from "./combineorders.vue?vue&type=template&id=4335886f&"
import script from "./combineorders.vue?vue&type=script&lang=js&"
export * from "./combineorders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports